import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static values = { text: { type: String, default: "Working…" } };

  connect() {
    this.boundStart = this.applyAll.bind(this);
    this.boundEnd = this.resetAll.bind(this);
    this.element.addEventListener("turbo:submit-start", this.boundStart);
    this.element.addEventListener("turbo:submit-end", this.boundEnd);
  }

  disconnect() {
    this.element.removeEventListener("turbo:submit-start", this.boundStart);
    this.element.removeEventListener("turbo:submit-end", this.boundEnd);
  }

  applyAll() {
    this.submitButtons().forEach((button) => this.applyLoading(button));
  }

  resetAll() {
    this.submitButtons().forEach((button) => this.resetLoading(button));
  }

  submitButtons() {
    return this.element.querySelectorAll(
      "button[type='submit'], input[type='submit']"
    );
  }

  applyLoading(button) {
    if (button.dataset.submittingApplied === "true") return;
    button.dataset.submittingApplied = "true";
    button.dataset.submittingOriginal =
      button.tagName === "INPUT" ? button.value : button.innerHTML;
    button.disabled = true;
    button.setAttribute("aria-busy", "true");

    if (button.tagName === "INPUT") {
      button.value = this.textValue;
      return;
    }

    button.innerHTML = "";
    const spinner = document.createElement("span");
    spinner.classList.add("spinner-border", "spinner-border-sm", "me-2");
    spinner.setAttribute("role", "status");
    spinner.setAttribute("aria-hidden", "true");
    button.appendChild(spinner);

    const label = document.createElement("span");
    label.textContent = this.textValue;
    button.appendChild(label);
  }

  resetLoading(button) {
    if (button.dataset.submittingApplied !== "true") return;

    button.disabled = false;
    button.removeAttribute("aria-busy");
    if (button.tagName === "INPUT") {
      button.value = button.dataset.submittingOriginal;
    } else {
      button.innerHTML = button.dataset.submittingOriginal;
    }
    delete button.dataset.submittingApplied;
    delete button.dataset.submittingOriginal;
  }
}
